// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__21YR6","inner":"Footer_inner__3yXdn","nextIcon":"Footer_nextIcon__1vuxS","innerLeft":"Footer_innerLeft__3Ppub"};